import { FC } from 'react'

import styled from 'styled-components'

import { Modal } from 'src/Components/Modal'
import { Button } from 'src/Components/Button'
import { colors } from 'src/Helpers/constants.ts'

import { ContactConflict } from './clientContactSync'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${colors.thirdBlue};
  font-size: 14px;
`

const ConflictRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Muted = styled.span`
  color: ${colors.thirdGray};
`

const Buttons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`

interface ClientContactSyncModalProps {
  clientName?: string
  conflicts: ContactConflict[]
  onConfirm: () => void
  onCancel: () => void
}

export const ClientContactSyncModal: FC<ClientContactSyncModalProps> = ({
  clientName,
  conflicts,
  onConfirm,
  onCancel,
}) => (
  <Modal
    opened={conflicts.length > 0}
    onClose={onCancel}
    title='Обновить ответственного в карточке клиента?'
    size='md'
  >
    <Content data-testid='client-contact-sync-modal'>
      <span>
        У клиента {clientName} эти поля уже заполнены другими значениями:
      </span>
      {conflicts.map((conflict) => (
        <ConflictRow key={conflict.field}>
          <strong>{conflict.label}</strong>
          <Muted>Сейчас в карточке: {conflict.current}</Muted>
          <span>В КП: {conflict.next}</span>
        </ConflictRow>
      ))}
      <Buttons>
        <Button variant='outline' onClick={onCancel}>
          Оставить как есть
        </Button>
        <Button onClick={onConfirm} data-testid='client-contact-sync-confirm'>
          Сохранить в карточку
        </Button>
      </Buttons>
    </Content>
  </Modal>
)
